module.exports = __webpack_public_path__ + "static/media/decryptor.62409d64.jpeg";